import React, { useEffect } from 'react';
import moment from 'moment';

import useGlobal from '../../../../store';
import Table from '../../../../facturotopia/table/Table';

const mapState = (store) => {
  return {
    facturacion: store.admin.reportes.facturacion.hits_clientes,
  };
};

const mapActions = (actions) => {
  return actions.admin.reportes.facturacion.hits_clientes;
};

const ReporteFacturacionClientesList = (props) => {
  const [state, actions] = useGlobal(mapState, mapActions);
  const { busy, data } = state.facturacion;

  useEffect(() => {
    if (data.length === 0) {
      const date = moment().format('YYYY-MM-DD');

      actions.paginate({
        page: 1,
        date,
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const paginate = (meta) => {
    actions.paginate(meta);
  };

  const handleOnPageChange = (page) => {
    const { date } = state.facturacion.filters;

    paginate({ page, date });
  };

  const handleOnPageLimitChange = (limit) => {
    const { date } = state.facturacion.filters;

    paginate({ limit, page: 1, date });
  };

  const getPaginationConfig = () => {
    const { pagination } = state.facturacion;

    return {
      metadata: pagination,
      onPageChange: handleOnPageChange,
      onPageLimitChange: handleOnPageLimitChange,
    };
  };

  const { onRowClick } = props;

  return (
    <Table
      loading={busy}
      columns={columns}
      rowKey={'id'}
      data={data}
      pagination={getPaginationConfig()}
      onRowClick={onRowClick}
      onRow={(item) => {
        return {
          className: item.highlight ? 'row-highlighted' : '',
        };
      }}
    ></Table>
  );
};

const columns = [
  {
    key: 'cliente',
    title: 'Cliente',
    dataIndex: 'cliente',
  },
  {
    key: 'enero',
    title: 'Ene',
    dataIndex: 'enero',
    className: 'text-right',
  },
  {
    key: 'febrero',
    title: 'Feb',
    dataIndex: 'febrero',
    className: 'text-right',
  },
  {
    key: 'marzo',
    title: 'Mar',
    dataIndex: 'marzo',
    className: 'text-right',
  },
  {
    key: 'abril',
    title: 'Abr',
    dataIndex: 'abril',
    className: 'text-right',
  },
  {
    key: 'mayo',
    title: 'May',
    dataIndex: 'mayo',
    className: 'text-right',
  },
  {
    key: 'junio',
    title: 'Jun',
    dataIndex: 'junio',
    className: 'text-right',
  },
  {
    key: 'julio',
    title: 'Jul',
    dataIndex: 'julio',
    className: 'text-right',
  },
  {
    key: 'agosto',
    title: 'Ago',
    dataIndex: 'agosto',
    className: 'text-right',
  },
  {
    key: 'septiembre',
    title: 'Sep',
    dataIndex: 'septiembre',
    className: 'text-right',
  },
  {
    key: 'octubre',
    title: 'Oct',
    dataIndex: 'octubre',
    className: 'text-right',
  },
  {
    key: 'noviembre',
    title: 'Nov',
    dataIndex: 'noviembre',
    className: 'text-right',
  },
  {
    key: 'diciembre',
    title: 'Dic',
    dataIndex: 'diciembre',
    className: 'text-right',
  },
];

export default ReporteFacturacionClientesList;
